import { GroupsList} from "./GroupsList";

export default GroupsList;
